import { render, staticRenderFns } from "./DeleteBibleDialog.vue?vue&type=template&id=2f752e40&scoped=true&"
import script from "./DeleteBibleDialog.vue?vue&type=script&lang=js&"
export * from "./DeleteBibleDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f752e40",
  null
  
)

export default component.exports